import script from "./BaseSnackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSnackbar.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSnackbar.vue?vue&type=style&index=0&id=89f9613c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89f9613c"]])